import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../../components/base/Icon";
import { TopTechnicianItem } from "../../models/AdminDashboardModel";

type Props = {
    items?: TopTechnicianItem[]
}

function initials(name?: string): string {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    return ((parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "")).toUpperCase();
}

function TopTechniciansWidget(props: Props) {
    const items = props.items ?? [];
    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5">
                <div>
                    <h3 className="widget-title">Top Technicians</h3>
                    <div className="widget-subtitle">This month · ranked by completed jobs</div>
                </div>
            </div>
            <div className="card-body pt-3">
                {items.length === 0 && (
                    <div className="text-center text-gray-500 py-8">
                        <Icon icon="wrench" type="thin" size={48} className="text-gray-400 mb-3" />
                        <div>No technician activity yet</div>
                    </div>
                )}
                {items.map((t, i) => (
                    <div key={t.id} className="tech-row d-flex align-items-center">
                        <div className="me-3 text-gray-500 fw-bold" style={{ minWidth: 18 }}>#{i + 1}</div>
                        <div className="tech-avatar me-3">
                            {t.avatarUrl ? <img src={t.avatarUrl} alt="" /> : <span>{initials(t.fullName)}</span>}
                        </div>
                        <div className="flex-grow-1 min-w-0">
                            <div className="fw-bold text-gray-900 text-truncate">{t.fullName || "Unknown"}</div>
                            <div className="text-gray-500 fs-7">{t.completedJobs} job{t.completedJobs === 1 ? "" : "s"} · ${t.revenue.toLocaleString()}</div>
                        </div>
                        <Link to={`/accounts/technicians/details/${t.id}`} className="btn btn-icon btn-sm btn-light-primary">
                            <Icon icon="chevron-right" type="solid" size={11} />
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TopTechniciansWidget;
